import * as React from 'react';
import Helmet from 'react-helmet';
import RescheduleForm, {
  AppointmentImminentWarning,
  AppointmentNonReschedulableWarning,
  AppointmentPassedWarning,
  AppointmentUnavailableWarning,
} from '../../../shared/components/RescheduleForm';
import Unauthorized from '../../../shared/components/Unauthorized';
import {
  hasPassed,
  isImminent,
  isReschedulable,
  isUnavailable,
} from '../../../shared/utils/appointmentUtils';
import isForbidden from '../../../shared/utils/isForbidden';
import WidgetHeader from '../../components/WidgetHeader';
import WidgetLayout from '../../components/WidgetLayout';
import LoadingPage from '../LoadingPage';
import NotFoundPage from '../NotFoundPage';
import styles from './ReschedulePage.scss';

interface ReschedulePageProps {
  data: {
    appointment: any;
  };
  loading: boolean;
  error?: Error | null;
}

export default function ReschedulePage({ data, loading, error }: ReschedulePageProps) {
  if (loading) return <LoadingPage />;
  if (isForbidden(error)) {
    return (
      <Unauthorized>
        <LoadingPage />
      </Unauthorized>
    );
  }
  if (error) return <WidgetLayout error={error} />;
  if (!data || !data.appointment) return <NotFoundPage />;

  const { appointment } = data;
  const { phone } = appointment.provider.office;
  const unavailable = isUnavailable(appointment);
  let content;
  if (hasPassed(appointment)) {
    content = <AppointmentPassedWarning phone={phone} />;
  } else if (isImminent(appointment) && !unavailable) {
    content = <AppointmentImminentWarning phone={phone} />;
  } else if (isReschedulable(appointment)) {
    content = <RescheduleForm appointment={appointment} />;
  } else {
    content = <AppointmentNonReschedulableWarning phone={phone} />;
  }
  return (
    <WidgetLayout
      header={
        <WidgetHeader
          title={
            unavailable
              ? 'Shoot, someone took your appointment while we were waiting for you to verify.'
              : 'Reschedule Your Appointment'
          }
          showBackButton={!unavailable}
        />
      }
    >
      <Helmet>
        <title>Reschedule your Appointment</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className={styles['reschedule-page__body']}>
        {unavailable && <AppointmentUnavailableWarning marginBottom="sm" />}
        {content}
      </div>
    </WidgetLayout>
  );
}
